import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerAppServiceWorker } from './util/serviceWorker';

// import {polyfill} from "mobile-drag-drop";

// polyfill();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />
);

registerAppServiceWorker();
